import { Spinner } from "@qw/ui";

import { formatChatSessionTitle } from "../chat.helpers";
import { useChatSession } from "../providers/chat-session-provider";

export const ChatSessionTitle = () => {
  const { chatSession, chatSessionsLoading } = useChatSession();

  if (chatSessionsLoading && !chatSession) {
    return <Spinner />;
  }

  if (!chatSession) {
    return null;
  }

  return (
    <div className="text-sm font-medium text-foreground truncate">
      {formatChatSessionTitle(chatSession.title || "New Chat Session")}
    </div>
  );
};
